import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RecomEnginePrivateRoute from './Auth/RecomEnginePrivateRoute';
import Pagenotfound from '../components/views/PageNotFound';
import RecomEngineLogin from './Auth/RecomEngineLogin';
import ToyRecommendation from './Toyrecommendations';
import RecommendationEngineLanding from './RecommendationEngineLanding';
import EmailOtpVerification from './Auth/TryLoginPage';

export default function RecommendationEngineRoute() {
  return (
    <div>
      <Routes>
        <Route path="/recommendation">
          <Route path="*" element={<Pagenotfound />} />
          <Route path="recommendationUtility" element={<RecommendationEngineLanding />} />
          <Route path="login" element={<EmailOtpVerification />} />
          <Route
            path="engine"
            element={
              <RecomEnginePrivateRoute>
                <ToyRecommendation />
              </RecomEnginePrivateRoute>
            }
          />
        </Route>
      </Routes>
    </div>
  );
}
